module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Status\n        ")]), _vm._v(" "), _c('claim-status')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Claim Type\n        ")]), _vm._v(" "), _c('claim-type')], 1), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease or Accident\n        ")]), _vm._v(" "), _c('disease-or-accident')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Disease Type\n        ")]), _vm._v(" "), _c('disease-type')], 1) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident' || _vm.claimType === 'personal_injury') ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Accident Type\n        ")]), _vm._v(" "), _c('accident-type')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n            Gender\n        ")]), _vm._v(" "), _c('gender')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3df99786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/form/BookOfBusinessSearch.vue
// module id = 1653
// module chunks = 0